class SubscriptionCheckbox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkbox = this.querySelector('.subs-checkbox');
    this.options = this.querySelector('.selling_plan-options');
    this.radios = this.querySelectorAll('[name="selling_plan"]'); // NEW

    if (!this.checkbox || !this.options) return;

    // initial
    this.options.style.overflow = "hidden";
    this.options.style.transition = "height .3s ease";
    this.options.style.height = "0px";

    // NEW — disable radios by default
    this.radios.forEach(r => r.disabled = true);

    // open if already checked
    if (this.checkbox.checked) {
      this._open();
      this.radios.forEach(r => r.disabled = false); // NEW
    }

    this.checkbox.addEventListener("change", () => {
      this.priceChange();

      if (this.checkbox.checked) {
        this.radios.forEach(r => r.disabled = false); // NEW
        this._open();
      } else {
        this.radios.forEach(r => r.disabled = true); // NEW
        this._close();
      }
    });
  }

  _open() {
    const fullHeight = this.options.scrollHeight;
    this.options.style.height = fullHeight + "px";

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.options.style.height = "auto";
    }, 260);
  }

  priceChange() {
    const productInfo = this.closest('product-info')
    const checkedTier = document.querySelector('.tier-form__input input[type=radio]:checked')
    if (!checkedTier) return;

    const price = checkedTier.dataset.subsPrice || checkedTier.dataset.salePrice
    const amount = checkedTier.dataset.subsNormal || checkedTier.dataset.saleNormal

    if (this.checkbox.checked) {
        productInfo.querySelector('.button-price').textContent = price
        if (document.querySelector('.sticky-button-el .button-price')) {
            document.querySelector('.sticky-button-el .button-price').textContent = price
        }
        document.querySelector('square-placement[id*="__afterpay_on_site_messaging_payments"]')?.setAttribute('data-amount', amount)
    } else {
        productInfo.querySelector('.button-price').textContent = checkedTier.dataset.salePrice
        if (document.querySelector('.sticky-button-el .button-price')) {
            document.querySelector('.sticky-button-el .button-price').textContent = checkedTier.dataset.salePrice
        }
        document.querySelector('square-placement[id*="__afterpay_on_site_messaging_payments"]')?.setAttribute('data-amount', checkedTier.dataset.saleNormal)
    }

    document.querySelectorAll('.tier-form__input input[type=radio]').forEach(input => {
        const parent = input.closest('.quantity-option-item')
        if (!parent) return;

        const salePriceEl = parent.querySelector('.sale-price')
        if (salePriceEl) {
            salePriceEl.textContent = this.checkbox.checked ? (input.dataset.subsPrice || input.dataset.salePrice) : input.dataset.salePrice
        }

        // Sync badge-tier text
        parent.querySelectorAll('.badge-tier[data-orig]').forEach(badge => {
            badge.textContent = this.checkbox.checked && badge.dataset.subs ? badge.dataset.subs : badge.dataset.orig
        })
    })
  }

  _close() {
    const fullHeight = this.options.scrollHeight;
    this.options.style.height = fullHeight + "px";

    requestAnimationFrame(() => {
      this.options.style.height = "0px";
    });
  }
}

customElements.define("subscription-checkbox", SubscriptionCheckbox);
